import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import { LogbookService } from '../../../../../services/logbook.service';
import {EmployeeService} from '../../../../../employee.service';
import {ExternalStaffService} from '../../../../../services/external-staff.service';
import {AuthorizationService} from '../../../../../services/authorization.service';
import { NbDialogService } from '@nebular/theme';
import { LogbooksAuthorizationComponentComponent } from '../../../../../authorizations/logbooks-authorization-module/logbooks-authorization-component/logbooks-authorization-component.component';
import { NewEmployeeComponent } from '../../../../../new-employee/new-employee.component';
import * as moment from 'moment';
import lodash from 'lodash';

@Component({
  selector: 'ngx-edit-product-logbook',
  templateUrl: './edit-product-logbook.component.html',
  styleUrls: ['./edit-product-logbook.component.scss'],
})
export class EditProductLogbookComponent implements OnInit {
  @ViewChild(SignaturePad, {static: true}) signaturePad: SignaturePad;

  signaturePadOptions: Object;
  loading: boolean = false;
  @Input() stationId: string;
  @Input() logbook: any = {
    fields: {
      previous_volume: 0,
      start_volume: 0,
      consignation: '',
      consignation_volume: 0,
      consignation_outVolume: 0,
      reception_volume: 0,
      end_volume: 0,
      sell_volume: 0,
      download_volume: 0,
      sale_while_download: 0,
      fuel_lost: 0,
      tank_return: 0,
      observations: '',
    },
  };
  @Output() refreshLogbook: EventEmitter<any> = new EventEmitter();
  imageBase64: any = '';
  readyData: boolean = false;
  employees = [];
  loadingLastVolume = false;
  externalStaff = [];
  authorizations = [];
  nextLogbookVolume: any = null;

  stationsWithOtherInterpretacionData = [
    'hxS6z2K1KRtZVDS9eYHi',
    'j71QAbYHYOwbmGThOmpn',
    '9hUFW1Q9pikEfqWxjwOT',
    'KFQHoGwQEZbOpKnFh673'
  ];

  isStationWithOtherInterpretation = false;

  constructor(
    private logbookService: LogbookService,
    private externalStaffService: ExternalStaffService,
    private employeeService: EmployeeService,
    private authorizationService: AuthorizationService,
    private dialogService: NbDialogService,
  ) {
  }

  async ngOnInit() {
    this.loading = true;
    this.logbook.date = new Date(this.logbook.date + 'T00:00:00');
    this.logbook.fields.register_whit_download_fuel = true;
    await Promise.all([
      this.getNextVolume(),
      this.getEmployees(),
      this.getAuthorizations(),
      this.getExternalStaffStation()
    ]);
    this.isStationWithOtherInterpretation = this.stationsWithOtherInterpretacionData.includes(this.stationId);
    this.readyData = true;
    this.loading = false;
    this.validateExternalStaff();
  }

  async getExternalStaffStation() {
    this.loading = true;
    const [err, response]: any = await this.externalStaffService.getExternalStaffStation(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista proveedores]', 'error');
    this.externalStaff = response.data;
  }

  async getAuthorizations() {
    this.loading = true;
    const [err, response]: any = await this.authorizationService.index(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops,', 'error', 'Intenta más tarde [Error. Lista de Autorizaciones]');
    this.authorizations = response.data;
  }

  async getEmployees() {
    this.loading = true;
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }

  async getLastAndNextVolume() {
    this.loading = true;
    const [error, { data: lastVolume }] = await this.logbookService.getLastVolumeProduct(this.stationId, this.logbook.fields.product, this.logbook.date, this.logbook.start_time);
    if (error) { this.loading = false; return error; }
    if (lastVolume) this.logbook.fields.previous_volume = lastVolume.fields.end_volume;
    await Promise.all([
      this.calculateValues(),
      this.getNextVolume(),
    ]);
    this.loading = false;

  }

  async getNextVolume() {
    this.nextLogbookVolume = {};
    this.loading = true;
    const [error, { data: nextVolume }] = await this.logbookService.getNextVolumeProduct(this.stationId, this.logbook.fields.product, this.logbook.date, this.logbook.start_time, this.logbook.id);
    if (error) { this.loading = false; return error; }
    this.nextLogbookVolume = nextVolume;
    this.loading = false;
  }

  openModal(isEdit = false) {
    this.dialogService.open(LogbooksAuthorizationComponentComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getAuthorizations() : console.error('no modificaron nada'));
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  validateForm() {
    this.storeLogbook()
  }

  async storeLogbook() {
    const validDataHasEmptyFields = Object.keys(this.logbook).includes('');
    const validFieldsHasEmptyFields = Object.keys(this.logbook.fields).includes('');

    if (validDataHasEmptyFields || validFieldsHasEmptyFields) {
      return Swal.fire({
        icon: 'error',
        title: 'Ingresa todos los datos necesiarios',
        text: '',
      });
    }
    this.logbook.stationId = this.stationId;
    this.logbook.fields.previous_volume = Number(this.logbook.fields.previous_volume);
    this.logbook.fields.start_volume = Number(this.logbook.fields.start_volume);
    this.logbook.fields.reception_volume = Number(this.logbook.fields.reception_volume);
    this.logbook.fields.consignation_volume = Number(this.logbook.fields.consignation_volume);
    this.logbook.fields.end_volume = Number(this.logbook.fields.end_volume);
    this.logbook.fields.sell_volume = Number(this.logbook.fields.sell_volume);
    this.logbook.fields.download_volume = Number(this.logbook.fields.download_volume);
    this.logbook.fields.fuel_lost = Number(this.logbook.fields.fuel_lost);
    this.logbook.fields.sale_while_download = Number(this.logbook.fields.sale_while_download);


    if (this.nextLogbookVolume && this.nextLogbookVolume.fields.previous_volume !== this.logbook.fields.end_volume) {
      const nextLogbookClone = await lodash.cloneDeep(this.nextLogbookVolume);
      const nextLogbookRecalculate = await this.recalculateValues(this.logbook, this.nextLogbookVolume);
      const message = `
      <p><strong>La siguiente bitacora podría sufrir cambios</strong></p>
      <table class="table mt-3">
        <thead>
          <tr style="font-size: 0.7em;">
            <th scope="col">Folio</th>
            <th scope="col">Fecha</th>
            <th scope="col">Volumen de recepción (B)</th>
            <th scope="col">Devolución al tanque (C)</th>
            <th scope="col">Volumen de venta (D)</th>
            <th scope="col">Hora inicio</th>
            <th scope="col">Volumen inicial (A)</th>
            <th scope="col">Hora término</th>
            <th scope="col">Volumen final (F)</th>
            <th scope="col">Inventario final calculado(E) = (A+B+C-D)</th>
            <th scope="col">Perdida de combustible (F-E)</th>
          </tr>
        </thead>
        <tbody style="font-size: 0.9em;">
          <tr class="text-danger-progess-bar">
            <td>${nextLogbookClone.folio}</td>
            <td>${nextLogbookClone.date}</td>
            <td>${nextLogbookClone.fields.reception_volume}</td>
            <td>${nextLogbookClone.fields.tank_return}</td>
            <td>${nextLogbookClone.fields.sell_volume}</td>
            <td>${nextLogbookClone.start_time}</td>
            <td>${nextLogbookClone.fields.previous_volume}</td>
            <td>${nextLogbookClone.end_time}</td>
            <td>${nextLogbookClone.fields.end_volume}</td>
            <td>${nextLogbookClone.fields.start_volume}</td>
            <td>${nextLogbookClone.fields.fuel_lost}</td>
          </tr>
          <tr class="text-success-progess-bar">
            <td>${nextLogbookRecalculate.folio}</td>
            <td>${nextLogbookRecalculate.date}</td>
            <td>${nextLogbookRecalculate.fields.reception_volume}</td>
            <td>${nextLogbookRecalculate.fields.tank_return}</td>
            <td>${nextLogbookRecalculate.fields.sell_volume}</td>
            <td>${nextLogbookRecalculate.start_time}</td>
            <td>${nextLogbookRecalculate.fields.previous_volume}</td>
            <td>${nextLogbookRecalculate.end_time}</td>
            <td>${nextLogbookRecalculate.fields.end_volume}</td>
            <td>${nextLogbookRecalculate.fields.start_volume}</td>
            <td>${nextLogbookRecalculate.fields.fuel_lost}</td>
          </tr>
        </tbody>
      </table>
      `;

      Swal.fire({
        title: '<strong>Estas seguro ?</strong>',
        icon: 'warning',
        html: message,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Modificar y actualizar bitacora',
        cancelButtonText: 'Cancelar',
        denyButtonText: 'Solo modificar',
        showDenyButton: true,
        customClass: { popup: 'swal2-popup-custom-width' },
      }).then(async (result: any) => {
        this.loading = true;
        let errorDelete = null;
        if (result.isDenied) [errorDelete] = await this.logbookService.updateByProduct(this.logbook.id, this.logbook);
        // delete and update
        if (result.isConfirmed) [errorDelete] = await this.logbookService.updateByProduct(this.logbook.id, this.logbook, 1);
        if (result.isDismissed) { this.loading = false; return; }

        this.loading = false;
        if (errorDelete)  return this.alert('Oops', 'error', 'Error al intentar actualizar bitacora');
        Swal.fire({
          title: 'Desea actualizar folios',
          icon: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Actualizar',
          cancelButtonText: 'Cancelar',
        }).then(async (updateFolios: any) => {
          if (updateFolios.isConfirmed) await this.folioNewAllProduct(this.logbook.fields.product, moment(this.logbook.date).year(), this.logbook.type);
          this.loading = false;
          this.refreshLogbook.emit(true);
          this.logbookService.exitEditLogbook()
        });
      });

    } else {
      const [error] = await this.logbookService.updateByProduct(this.logbook.id, this.logbook);
      this.loading = false;
      if (error) { alert('Ha ocurrido un error, intenta màs tarde'); return error; }
      this.refreshLogbook.emit(true);
      this.logbookService.exitEditLogbook()
    }
  }

  async folioNewAllProduct(product, year, type) {
    const typeName = 'Desviación en el balance de producto';
    const productName = product === 'standard' ? '87 Octanos' : product === 'premium' ? '91 Octanos' : 'Diesel';
    await Swal.fire({
      title: '¿Estas seguro?',
      text: `Actualizará los folios de ${productName} de las bitacoras de "${typeName}" creadas en ${year}. Esta acción no se puede revertir.`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, estoy seguro',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.value) {
        this.loading = true;
        const [error] = await this.logbookService.folioNewAllProduct(this.stationId, type, { year, column_field: 'product', value_field: product });
        this.loading = false;
        if (error) return error;
        await Swal.fire(
          'Bitácoras foliadas',
          '',
          'success',
        );
      }
    });
  }

  async validateExternalStaff() {
    if (this.logbook.responsable !== 'otro') {
      this.logbook.external_staff = {
        provider: '',
        responsable: '',
      };
      return;
    } else if (!this.logbook.external_staff.provider) {
      this.logbook.external_staff = {
        provider: '',
        responsable: '',
      };
    }
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async calculateValues() {
    this.logbook.fields.reception_volume = this.logbook.fields.reception_volume ? this.logbook.fields.reception_volume : 0;
    console.log(this.logbook.fields.reception_volume);
    this.logbook.fields.consignation_volume = this.logbook.fields.consignation_volume ? this.logbook.fields.consignation_volume : 0;
    console.log(this.logbook.fields.consignation_volume);
    this.logbook.fields.start_volume = await (Number(this.logbook.fields.previous_volume) + Number(this.logbook.fields.tank_return) + Number(this.logbook.fields.reception_volume) + Number(this.logbook.fields.consignation_volume)) - Number(this.logbook.fields.sell_volume) - Number(this.logbook.fields.consignation_outVolume);
    console.log(this.logbook.fields.start_volume);
    if (this.isStationWithOtherInterpretation) {
      // CIMA DEL TAJIN DIFERENTE INTERPRETACIÓN
      this.logbook.fields.fuel_lost = await Number(this.logbook.fields.start_volume) - Number(this.logbook.fields.end_volume);
    } else {
      this.logbook.fields.fuel_lost = await Number(this.logbook.fields.end_volume) - Number(this.logbook.fields.start_volume);
      console.log(this.logbook.fields.fuel_lost);
    }
  }

  async recalculateValues(logbook, nextLobook) {
    nextLobook.fields.previous_volume = logbook.fields.end_volume;
    nextLobook.fields.start_volume = await (Number(nextLobook.fields.previous_volume) + Number(nextLobook.fields.tank_return) + Number(nextLobook.fields.reception_volume) + Number(nextLobook.fields.consignation_volume)) - Number(nextLobook.fields.sell_volume);
    if (this.isStationWithOtherInterpretation) {
      // CIMA DEL TAJIN DIFERENTE INTERPRETACIÓN
      nextLobook.fields.fuel_lost = await Number(nextLobook.fields.start_volume) - Number(nextLobook.fields.end_volume);
    } else {
      nextLobook.fields.fuel_lost = await Number(nextLobook.fields.end_volume) - Number(nextLobook.fields.start_volume);
    }
    return nextLobook;
  }

  registerWhitDownloadFuelAction() {
    this.logbook.register_whit_download_fuel = !this.logbook.register_whit_download_fuel;
  }

}
